// import React, { useState, useEffect } from 'react';
// import { 
//   FaInstagram, FaWhatsapp, FaBars, FaTimes, FaPhone, FaEnvelope 
// } from 'react-icons/fa';
// import './Header.css';

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [showContactModal, setShowContactModal] = useState(false);
//   const [activeSection, setActiveSection] = useState("home");

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleContactClick = (e) => {
//     e.preventDefault();
//     setShowContactModal(true);
//     setIsMenuOpen(false); // close menu when clicked
//   };

//   const handleRegisterClick = () => {
//     const formSection = document.getElementById('form');
//     if (formSection) {
//       formSection.scrollIntoView({ behavior: 'smooth' });
//     }
//     setIsMenuOpen(false); // close mobile menu
//   };

//   const handleWhatsAppClick = () => {
//     const whatsappNumber = "+919012052552";
//     const message = "Hi! I'm interested in Ghoomo India tours.";
//     const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
//     window.open(whatsappUrl, '_blank');
//   };

//   const handleWhatsAppGroupClick = () => {
//     const whatsappGroupUrl = "https://chat.whatsapp.com/Hc4QpUp8j3l8sJefILgRXb";
//     window.open(whatsappGroupUrl, '_blank');
//   };

//   // Scroll spy for active section
//   useEffect(() => {
//     const sections = document.querySelectorAll("section[id]");
//     const handleScroll = () => {
//       let current = "home";
//       sections.forEach((section) => {
//         const sectionTop = section.offsetTop - 100;
//         if (window.scrollY >= sectionTop) {
//           current = section.getAttribute("id");
//         }
//       });
//       setActiveSection(current);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Scroll to section and close mobile menu
//   const handleNavLinkClick = (sectionId) => {
//     const section = document.getElementById(sectionId);
//     if(section) {
//       section.scrollIntoView({ behavior: 'smooth' });
//     }
//     setIsMenuOpen(false);
//   };

//   return (
//     <>
//       {/* Top Contact Bar */}
//       <div className="top-bar">
//         <div className="container">
//           <div className="top-bar-content">
//             <div className="contact-info">
//               <span>
//                 <FaPhone className="contact-icon-inline" /> +91 90120 52552
//               </span>
//               <span>
//                 <FaEnvelope className="contact-icon-inline" /> ghoomoindiaa@gmail.com
//               </span>
//             </div>
//             <div className="social-links">
//               <a
//                 href="https://www.instagram.com/ghoomo.india__?utm_source=ig_web_button_share_sheet&igsh=MWd6Nzc1Z2YxaXAyYw=="
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaInstagram />
//               </a>
//               <a
//                 href="https://wa.me/919012052552"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaWhatsapp />
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Navigation */}
//       <nav className="navbar">
//         <div className="container">
//           <div className="nav-content">
//             <div className="logo" aria-label="Ghoomo India">
//               <img 
//                 src="https://i.pinimg.com/736x/c9/90/e7/c990e75728c9c9bd9eaf755b96d4ae2c.jpg" 
//                 alt="Ghoomo India Logo" 
//                 className="logo-img"
//               />
//               <span className="logo-text">
//                 <span className="logo-strong">Ghoomo</span>
//                 <span className="logo-accent">India</span>
//               </span>
//             </div>
            
//             <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
//               <a href="#home" className={`nav-link ${activeSection === "home" ? "active" : ""}`} onClick={() => handleNavLinkClick("home")}>Home</a>
//               <a href="#about" className={`nav-link ${activeSection === "about" ? "active" : ""}`} onClick={() => handleNavLinkClick("about")}>About</a>
//               <a href="#services" className={`nav-link ${activeSection === "services" ? "active" : ""}`} onClick={() => handleNavLinkClick("services")}>Services</a>
//               <a href="#packages" className={`nav-link ${activeSection === "packages" ? "active" : ""}`} onClick={() => handleNavLinkClick("packages")}>Photo Gallery</a>
//               <a href="#contact" className={`nav-link ${activeSection === "contact" ? "active" : ""}`} onClick={handleContactClick}>Contact</a>
//             </div>

//             <div className="nav-actions">
//               <button className="btn btn-primary" onClick={handleRegisterClick}>Register</button>
//               <button className="mobile-menu-btn" onClick={toggleMenu}>
//                 {isMenuOpen ? <FaTimes /> : <FaBars />}
//               </button>
//             </div>
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// };

// export default Header;




import React, { useState, useEffect } from 'react';
import { 
  FaInstagram, FaWhatsapp, FaBars, FaTimes, FaPhone, FaEnvelope 
} from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Handle Contact click — opens modal & closes menu (works on mobile too)
  const handleContactClick = (e) => {
    e.preventDefault();
    setShowContactModal(true);
    setIsMenuOpen(false);
  };

  // Smooth scroll to Register form & close menu
  const handleRegisterClick = () => {
    const formSection = document.getElementById('form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  // WhatsApp personal chat
  const handleWhatsAppClick = () => {
    const whatsappNumber = "+919012052552";
    const message = "Hi! I'm interested in Ghoomo India tours.";
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  // WhatsApp group link
  const handleWhatsAppGroupClick = () => {
    const whatsappGroupUrl = "https://chat.whatsapp.com/Hc4QpUp8j3l8sJefILgRXb";
    window.open(whatsappGroupUrl, '_blank');
  };

  // Scroll spy for highlighting active section
  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");
    const handleScroll = () => {
      let current = "home";
      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 100;
        if (window.scrollY >= sectionTop) {
          current = section.getAttribute("id");
        }
      });
      setActiveSection(current);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Handle link clicks - smooth scroll + close mobile menu
  const handleNavLinkClick = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Top Contact Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="contact-info">
              <span>
                <FaPhone className="contact-icon-inline" /> +91 90120 52552
              </span>
              <span>
                <FaEnvelope className="contact-icon-inline" /> ghoomoindiaa@gmail.com
              </span>
            </div>
            <div className="social-links">
              <a
                href="https://www.instagram.com/ghoomo.india__?utm_source=ig_web_button_share_sheet&igsh=MWd6Nzc1Z2YxaXAyYw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://wa.me/919012052552"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            <div className="logo" aria-label="Ghoomo India">
              <img 
                src="https://i.pinimg.com/736x/c9/90/e7/c990e75728c9c9bd9eaf755b96d4ae2c.jpg" 
                alt="Ghoomo India Logo" 
                className="logo-img"
              />
              <span className="logo-text" style={{ fontFamily: 'Oswald, sans-serif' }}>
                <span className="logo-strong">Ghoomo</span>
                <span className="logo-accent">India</span>
              </span>
            </div>
            
            <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
              <a href="#home" className={`nav-link ${activeSection === "home" ? "active" : ""}`} onClick={() => handleNavLinkClick("home")}>Home</a>
              <a href="#about" className={`nav-link ${activeSection === "about" ? "active" : ""}`} onClick={() => handleNavLinkClick("about")}>About</a>
              <a href="#services" className={`nav-link ${activeSection === "services" ? "active" : ""}`} onClick={() => handleNavLinkClick("services")}>Services</a>
              <a href="#packages" className={`nav-link ${activeSection === "packages" ? "active" : ""}`} onClick={() => handleNavLinkClick("packages")}>Photo Gallery</a>
              <a href="#contact" className={`nav-link ${activeSection === "contact" ? "active" : ""}`} onClick={handleContactClick}>Contact</a>
            </div>

            <div className="nav-actions">
              <button className="btn btn-primary" onClick={handleRegisterClick}>Register</button>
              <button className="mobile-menu-btn" onClick={toggleMenu}>
                {isMenuOpen ? <FaTimes /> : <FaBars />}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Contact Modal */}
      {showContactModal && (
        <div className="contact-modal-overlay" onClick={() => setShowContactModal(false)}>
          <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
            <div className="contact-modal-header">
              <h3>Contact Us</h3>
              <button className="close-btn" onClick={() => setShowContactModal(false)}>
                <FaTimes />
              </button>
            </div>
            <div className="contact-modal-content">
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div>
                  <h4>Phone Number</h4>
                  <p>+91 90120 52552</p>
                </div>
              </div>
              <div className="contact-item">
                <FaWhatsapp className="contact-icon" />
                <div>
                  <h4>WhatsApp</h4>
                  <p>+91 90120 52552</p>
                  <button className="whatsapp-btn" onClick={handleWhatsAppClick}>
                    Chat on WhatsApp
                  </button>
                </div>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <h4>Email</h4>
                  <p>ghoomoindiaa@gmail.com</p>
                </div>
              </div>
              <div className="contact-item">
                <FaWhatsapp className="contact-icon" />
                <div>
                  <h4>WhatsApp Group</h4>
                  <p>Join our group for future updates</p>
                  <button className="whatsapp-group-btn" onClick={handleWhatsAppGroupClick}>
                    Join WhatsApp Group
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
